module.exports = __webpack_public_path__ + "static/media/asset.cb8cfc4b.png";